/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'

const KnowledgeBaseBredcrumb: Array<PageLink> = [
  {
    title: 'Home',
    path: '',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const KnowledgeBasePage: FC = () => (
  <>
    <div className='card p-5'>
      <h1>Knowlwege Base Page</h1>
    </div>
  </>
)

const KnowledgeBaseWrapper: FC = () => {
  return (
    <>
      <KnowledgeBasePage />
    </>
  )
}

export {KnowledgeBaseWrapper}
